import type { KpiCardSpec } from './card-spec';
import type { KpiForm, KpiThemePalette } from './types';

const CHART_FORMS: readonly KpiForm[] = [
    'pie',
    'bars',
    'columns',
    'line',
    'multiline',
    'downloads',
];

const AREA_FORMS: readonly KpiForm[] = ['line', 'multiline'];

/** Pure: never mutates `spec`. Boxes `number`/`rate` tiles, gives chart forms
 * the tab's `theme` palette, draws `line`/`multiline` as a gradient area and
 * stacks a `pie` legend below the ring unless it asks for `legendBeside`; a flag
 * the spec already sets wins. */
export const withDashboardLook = (
    spec: KpiCardSpec,
    theme: KpiThemePalette
): KpiCardSpec => {
    const patch: Pick<
        KpiCardSpec,
        'boxed' | 'palette' | 'chartStyle' | 'legendBelow'
    > = {};

    if (
        (spec.form === 'number' || spec.form === 'rate') &&
        spec.boxed === undefined
    ) {
        patch.boxed = true;
    }
    if (CHART_FORMS.includes(spec.form) && spec.palette === undefined) {
        patch.palette = theme;
    }
    if (AREA_FORMS.includes(spec.form) && spec.chartStyle === undefined) {
        patch.chartStyle = 'area';
    }
    if (
        spec.form === 'pie' &&
        spec.legendBelow === undefined &&
        spec.legendBeside === undefined
    ) {
        patch.legendBelow = true;
    }

    return Object.keys(patch).length > 0 ? { ...spec, ...patch } : spec;
};

export const withDashboardLookAll = (
    cards: KpiCardSpec[],
    theme: KpiThemePalette
): KpiCardSpec[] => cards.map((card) => withDashboardLook(card, theme));
